import '@google/model-viewer';
import './App.css';
import { useState } from 'react';


function urlMdl(nMdl) {
  return (
    './assets/models/' +
    nMdl +
    '.glb'
  )
};

function App() {

  const [mdl, setMdl] = useState('./assets/models/canard.glb')

  return (
    <div>
      <button onClick={() => setMdl(urlMdl("stegosaure"))}>stegosaure</button>
      <button onClick={() => setMdl(urlMdl("canard"))}>canard</button>

      <model-viewer
        src={mdl}
        ar ar-modes="scene-viewer quick-look"
        xr-environment
        camera-controls
        touch-action="pan-y"
      ></model-viewer>
    </div>

  );
}

export default App;
